module.exports = __webpack_public_path__ + "static/media/H4_groot hout.72b80c33.png";